<template>
    <section class="configurations-page">
        <section class="title">
            <h1>Departamentos</h1>
            <p>Aqui está todas as opções para personalização do uso do sistema.</p>
        </section>
        <section class="cards">

            <ui-no-result text="Nenhum tipo de usuário registrado" class="mb-20" />
            <section>
                <div class="items">
                    <div class="item">
                        <div>Marketing</div>
                        <div>
                            <button type="button" @click="showModal('modal-remove')">
                                <i class="fal fa-trash-alt"></i>
                            </button>
                        </div>
                    </div>
                    <div class="item">
                        <div>Recursos Humanos</div>
                        <div>
                            <button type="button" @click="showModal('modal-remove')">
                                <i class="fal fa-trash-alt"></i>
                            </button>
                        </div>
                    </div>
                    <div class="item">
                        <div>Comercial</div>
                        <div>
                            <button type="button" @click="showModal('modal-remove')">
                                <i class="fal fa-trash-alt"></i>
                            </button>
                        </div>
                    </div>
                    <div class="item">
                        <div>Fornecedores</div>
                        <div>
                            <button type="button" @click="showModal('modal-remove')">
                                <i class="fal fa-trash-alt"></i>
                            </button>
                        </div>
                    </div>
                    <div class="item">
                        <div>Clientes</div>
                        <div>
                            <button type="button" @click="showModal('modal-remove')">
                                <i class="fal fa-trash-alt"></i>
                            </button>
                        </div>
                    </div>
                </div>
            </section>
        
            <div class="controls">
                <button type="button" @click="showModal('modal-add')">
                    <i class="fal fa-plus"></i>
                </button>
            </div>
        </section>

        <ui-modal id="modal-add" title="Departamento" title-text="Escreva o nome do novo departamento" size="sm">
            <form>
                <div class="input-box">
                    <input id="input-empresa" type="text" placeholder="Digite o seu e-mail">
                    <label for="input-empresa">
                        <span>Nome:</span>
                    </label>
                </div>
                <div class="control">
                    <button type="submit">Salvar</button>
                </div>
            </form>
        </ui-modal>

        <ui-modal id="modal-remove" title="Confirmar Exclusão" title-text="Tem certeza que deseja excluir esse departamento?" size="xs">
            <div class="control">
                <button type="button" class="btn-cancel" @click="hideModal('modal-remove')">Cancelar</button>
                <button type="button" class="btn-confirm">Confirmar</button>
            </div>
        </ui-modal>

    </section>
</template>

<script>
    import { uiModal, uiNoResult } from '@/components'
    export default {
        components: { uiModal, uiNoResult },
        data() {
            return {}
        },
        methods: {
            showModal(modalID){
                this.$root.$emit("modal", modalID);
            },
            hideModal(modalID){
                this.$root.$emit("modal-close", modalID);
            }
        },
        created(){
			
		}
    }
</script>


<style lang="stylus" scoped>
    @import 'styles.styl';
</style>
